import React from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';

import { RadialChartItem } from 'features/dashboard/ts/RadialChartItem';
import { useStyles } from 'features/dashboard/components/RechartsRadialChart/styles';
import { ORDER_SUMMARY_COLORS } from 'features/dashboard/constants/orderSummaryColors';

const RADIAN = Math.PI / 180;
const ACTIVE_MULTIPLIER = 1.2;

const createActiveShapeRenderer = (pieTextClassName: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (props: any) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (outerRadius + -23) * cos;
    const my = cy + (outerRadius + -23) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 1;
    const ey = my;

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={innerRadius - innerRadius * (ACTIVE_MULTIPLIER - 1)}
          outerRadius={outerRadius * ACTIVE_MULTIPLIER}
          fill={fill}
        />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 1}
          y={ey}
          dy={1}
          textAnchor="middle"
          fill="white"
          className={pieTextClassName}
        >
          {(percent * 100) ^ 0}%
        </text>
      </g>
    );
  };
};

interface RechartRadialChartProps {
  data: RadialChartItem[];
}

const fakeData = [{ total: 100 }];

export const RechartRadialChart: React.FC<RechartRadialChartProps> = ({ data }) => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handlePieEnter = React.useCallback((_: unknown, index: number) => {
    setActiveIndex(index);
  }, []);

  const activeShape = React.useMemo(() => createActiveShapeRenderer(classes.pieText), [classes]);

  return (
    <ResponsiveContainer width="100%" height={300} className={classes.root}>
      <PieChart className={classes.root}>
        <Pie
          className={classes.root}
          data={fakeData}
          cx="50%"
          cy="50%"
          innerRadius="45%"
          outerRadius="80%"
          fill="#F2F2F2"
          dataKey="total"
          onMouseEnter={handlePieEnter}
        />
        <Pie
          className={classes.root}
          activeIndex={activeIndex}
          activeShape={activeShape}
          data={data}
          cx="50%"
          cy="50%"
          innerRadius="45%"
          outerRadius="80%"
          dataKey="total"
          onMouseEnter={handlePieEnter}
          enableBackground="black"
        >
          {data.map((entry, index) => (
            <Cell key={entry.name} fill={ORDER_SUMMARY_COLORS[index % ORDER_SUMMARY_COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
